import { render } from "./BlockCard.vue?vue&type=template&id=9a11ceb2&ts=true"
import script from "./BlockCard.vue?vue&type=script&lang=ts"
export * from "./BlockCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__